const animTiming = {
    duration: 400,
    easing: "ease-out"
};

const detailsElements = document.querySelectorAll(".js-faq-details");

detailsElements.forEach(details => {
    const summary = details.querySelector(".js-faq-summary");
    const content = details.querySelector(".js-faq-answer");

    // Set initial styles
    content.style.overflow = 'hidden';
    content.style.height = details.hasAttribute("open") ? 'auto' : '0';
    content.style.opacity = details.hasAttribute("open") ? '1' : '0';
    content.style.transition = `height ${animTiming.duration}ms ${animTiming.easing}, opacity ${animTiming.duration}ms ${animTiming.easing}`;

    summary.addEventListener("click", (event) => {
        event.preventDefault();

        if (details.hasAttribute("open")) {
            content.style.height = content.offsetHeight + 'px'; // Set the current height
            // Force a reflow to make sure the above line takes effect before the next line
            window.getComputedStyle(content).height; 
            content.style.height = '0px';
            content.style.opacity = '0';
        } else {
            details.setAttribute("open", "true"); // Add the open attribute
            content.style.height = content.scrollHeight + 'px'; // Set to its full height
            content.style.opacity = '1';
        }
    });

    content.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'height') {
            if (content.style.height === '0px') {
                details.removeAttribute("open");
            } else {
                content.style.height = 'auto'; // Reset height to auto when the accordion is open
            }
        }
    });
});